/* eslint-disable react/prop-types */
import './aboutHotel.scss';
import cx from 'classnames';
import Description from '../../../../common/description';
import Titles from '../../components/titles';

const AboutHotel = ({ hotelContent, isActive, siteSettings, labels }) => {
  const { name, geographical, ratings, paragraphs } = hotelContent;

  const officialHotelRatingParagraph = {
    desktop: '',
    expanded: ratings?.officialRating
      ? labels?.officialRating.replace('{rating}', ratings.officialRating)
      : labels?.officialRatingMissing,
    mobile: '',
  };

  return (
    <div
      className={cx('gw-hotel-info-about-hotel', {
        'gw-hotel-info-about-hotel--hidden': !isActive,
      })}
    >
      <h2>{labels?.descriptionHeading}</h2>
      <Description
        paragraphs={paragraphs}
        showMoreText={labels?.showMoreText}
        hideText={labels?.showLessText}
        geoType="hotel"
        mobileHeading={
          <Titles
            siteId={siteSettings?.siteId}
            geographical={geographical}
            rating={ratings?.standard}
            hotelName={name}
          />
        }
        officialHotelRatingParagraph={officialHotelRatingParagraph}
        isAlwaysExpanded
      />
    </div>
  );
};

export default AboutHotel;
